import Reveal from './Reveal';
import './PageHero.css';

export default function PageHero({ eyebrow, title, body }) {
  return (
    <section className="page-hero">
      <div className="container">
        <Reveal className="page-hero-inner">
          <span className="eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          {body && <p>{body}</p>}
        </Reveal>
      </div>
    </section>
  );
}
